export default __webpack_public_path__ + "static/media/February2021.968608d3.png";